import { useMenuModal } from 'contexts/MenuModalContext';
import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-client';
import { BreadcrumbDirection } from 'types/models';

interface ChoiceTransitionDivProps {
  children: React.ReactNode;
  classNames?: string;
  ignoreEntry?: boolean;
}

export const ChoiceTransitionDiv: React.FC<ChoiceTransitionDivProps> = ({
  children,
  classNames,
  ignoreEntry = false,
}) => {
  const { direction } = useMenuModal();
  const entryPosition = ignoreEntry ? '0vw' : '50px';
  return (
    <AnimatePresence mode="wait">
      <motion.div
        className={classNames}
        initial={{
          x: `${
            direction === BreadcrumbDirection.Forward ? entryPosition : '-50px'
          }`,
          opacity: 0,
        }}
        animate={{ x: 0, opacity: 1 }}
        exit={{
          x: `${direction === BreadcrumbDirection.Forward ? '-50px' : '50px'}`,
          opacity: 0,
        }}
        transition={{ type: 'tween', duration: 0.3, ease: 'easeOut' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
